import { Draft } from 'immer';
import { v4 as uuid } from 'uuid';

import { Store } from 'app/interfaces';
import { TransactionType } from 'app/interfaces/common';

export default function setTransactionID(
  state: Draft<Store.State>,
  newId = uuid(),
  transactionType: TransactionType
): void {
  state.transactions[transactionType].ID = newId;
}
